export default __webpack_public_path__ + "static/media/bmo-logo.8b356a20.svg";